import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../app/hooks";
import { changeLanguage } from "../../localization/localizationSlice";
import { setActiveVocabulary } from "../../organization/utils/vocabularyI18n";
import { PortalMe } from "../models/PortalMe";
import { pickPortalLanguage, readPortalLanguageChoice } from "../utils/portalLanguage";

/**
 * Once the signed-in member is known, opens the portal in their own language
 * (unless the visitor picked one) and pushes the organization's words
 * (Fahrschüler, Fahrstunde …) into every translated string.
 */
export const usePortalLocalization = (me: PortalMe | null): void => {
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const bootedFor = useRef<string | null>(null);
  const memberId = me?.self.memberId ?? null;
  const memberLanguage = me?.self.languageCode ?? null;
  const vocabulary = me?.organization.vocabulary ?? null;

  useEffect(() => {
    if (!memberId || bootedFor.current === memberId) return;
    bootedFor.current = memberId;
    const target = pickPortalLanguage(memberLanguage, i18n.language, readPortalLanguageChoice());
    if (target) {
      dispatch(changeLanguage(target));
    }
  }, [dispatch, i18n, memberId, memberLanguage]);

  useEffect(() => {
    if (vocabulary) {
      setActiveVocabulary(i18n, vocabulary);
    }
  }, [i18n, vocabulary]);
};
